/* eslint-disable @typescript-eslint/no-empty-interface */
import { useConfig, useDesktop, useOidc, useProduct } from '@revenuewell/front-end-bundle';
import React, { useEffect } from 'react';
import { useKazoo } from '../hooks/use-kazoo';
import { usePhone, useWebPhone } from '../hooks/use-phone';
import { usePhoneWidgetProps } from '../hooks/use-phone-widget-props';
import { VoiceApi } from '../services/api-client/voice-api';
import { CallList } from './call/call-list';

export interface IPhoneWidgetProps {
  events?: {
    onPatientProfileClick?(phoneNumber: string): void;
  };
}

const DefaultPhoneWidget: React.FC<IPhoneWidgetProps> = (props) => {
  const { init } = usePhone();
  const { config } = useConfig();
  const { oidcService } = useOidc();
  const { setWidgetProps } = usePhoneWidgetProps();
  const { userCredentials: credentials, userInfoStatus } = useKazoo();
  // const { refreshParkedCallsList } = useCallParking()

  useWebPhone();

  if (config && oidcService) {
    VoiceApi.initialize(config, oidcService);
  }

  useEffect(() => {
    setWidgetProps(props);
  }, [props]);

  // useEffect(() => {
  //   if (credentials) {
  //     refreshParkedCallsList()
  //   }
  // }, [credentials]);

  useEffect(() => {
    if (!['pending', 'default'].includes(userInfoStatus)) {
      init();
    }
  }, [userInfoStatus]);

  return <CallList />;
};

export const PhoneWidget: React.FC<IPhoneWidgetProps> = (props) => {
  const { isDesktopApplication, isDesktopWidget } = useDesktop();
  const { hasProduct } = useProduct();

  return !hasProduct('phone2') || (isDesktopApplication() && !isDesktopWidget) ? null : (
    <DefaultPhoneWidget {...props} />
  );
};
